const getUser = () => JSON.parse(localStorage.getItem("userDetails") || null);
const getDashboardUser = () => localStorage.getItem("userDetails" || null);
const clearUserData = () => localStorage.clear();

export { getUser, getDashboardUser, clearUserData };
